"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var run_exports = {};
__export(run_exports, {
  permissionCheckPasses: () => permissionCheckPasses,
  runPermissionCheck: () => runPermissionCheck
});
module.exports = __toCommonJS(run_exports);
var import_fp = require("@cartographerio/fp");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_runCanGrantQualification = require("./runCanGrantQualification.js");
var import_runCanGrantRole = require("./runCanGrantRole.js");
var import_runHasQualification = require("./runHasQualification.js");
var import_runHasRole = require("./runHasRole.js");
function permissionCheckPasses(check, params, graph = null) {
  switch (check.type) {
    case "Always":
      return true;
    case "Never":
      return false;
    case "CanGrantRole":
      if (graph == null) {
        throw (0, import_types.internalError)("Tried running GanGrantRole permission check without a workspace graph!");
      } else {
        return (0, import_runCanGrantRole.canGrantRole)(params.roles, graph, check.role);
      }
    case "CanGrantQualification":
      return (0, import_runCanGrantQualification.canGrantQualification)(params.roles, params.qualificationRoles, check.role);
    case "HasQualification":
      return (0, import_runHasQualification.hasQualification)(params.roles, params.qualificationRoles, check.role);
    case "HasRole":
      return (0, import_runHasRole.hasRole)(params.roles, check.role);
    case "HasAccount":
      return params.id != null;
    case "HasUserId":
      return params.id === check.userId;
    case "And":
      return check.args.every((arg) => permissionCheckPasses(arg, params, graph));
    case "Or":
      return check.args.some((arg) => permissionCheckPasses(arg, params, graph));
    case "InAnyWorkspace":
      return (0, import_runHasRole.hasWorkspaceRole)(params.roles, check.name);
    case "Named":
      return permissionCheckPasses(check.check, params, graph);
    case "WorkspaceAccess":
      if (graph == null) {
        throw (0, import_types.internalError)("Tried running WorkspaceAccess permission check without a workspace graph!");
      } else {
        return params.roles.includes(import_types.superuserRole) || import_fp.Option.wrap(graph.optFindWorkspaceById(check.workspaceId)).fold(
          () => false,
          (ws) => (0, import_types.workspaceAccessLevelGte)(ws.accessLevel, check.minAccess)
        );
      }
    default:
      return (0, import_util.checkExhausted)(check);
  }
}
function runPermissionCheck(check, user, graph) {
  if (!permissionCheckPasses(check, user, graph)) {
    throw (0, import_types.forbiddenError)(check, user);
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  permissionCheckPasses,
  runPermissionCheck
});
//# sourceMappingURL=run.js.map
